import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Stack from "@mui/material/Stack";
import { CreditCard as CreditCardIcon } from "@phosphor-icons/react/CreditCard";
import { FC } from "react";
import { TrialRemainingCard } from "~ui-components/index";
import {
	Account,
	AccountUsageStats,
} from "~ui-components/types/__generated/gql/graphql";
import { Summary } from "../subscription-summary";

export const TrialUserAccount: FC<{
	account: Account;
	accountUsageStats: AccountUsageStats;
}> = (props) => {
	return (
		<Card>
			<CardHeader
				avatar={
					<Avatar>
						<CreditCardIcon fontSize="var(--Icon-fontSize)" />
					</Avatar>
				}
				title="Subscription"
			/>
			<CardContent>
				<Stack
					direction={{ xs: "column", sm: "row" }}
					spacing={3}>
					<Stack
						spacing={3}
						sx={{
							flex: "0 0 auto",
							justifyContent: "space-between",
							width: "100%",
						}}>
						<TrialRemainingCard {...props} />
						<Summary {...props} />
					</Stack>
				</Stack>
			</CardContent>
		</Card>
	);
};
